// ============================================================================
// CANCUN100 — marcaC100.js  (Bloque 09: marca de los PDF descriptivos)
// ----------------------------------------------------------------------------
// Constante ÚNICA de marca para los descriptivos (Premium y Básico). Cambiar aquí
// logo, colores, contacto o footer legal y se refleja en todos los PDFs de producto.
// Mismos datos institucionales que ya imprimen los PDFs de cupón (PDFCliente.jsx).
// ============================================================================
import { TEL_OFICINA, WA_SALA } from '../contacto';
import { LOGO_BASE64 } from '../pdf/logoBase64';

export const MARCA_C100 = {
  nombre: 'Cancun100',
  logo: LOGO_BASE64,
  color1: '#f74780',   // rosa de la app (el Premium oscurece el fondo hasta contraste ≥ 4.5 con blanco)
  color2: '#ff8c42',   // naranja de la app
  paleta: 'atardecer', // gradiente del Básico
  contacto: {
    telefono: TEL_OFICINA,          // Tel Oficina (src/contacto.js)
    whatsapp: '+52 ' + WA_SALA,     // WhatsApp oficial; en Top Tours se cambia por el de "Aventuras con Pao" (DescriptivoBoton)
    email: 'info@cancun100.com',
    web: 'cancun100.com',
  },
  footer: 'cancun100.com by Xpectative Travel · Calle Tejón 14, Cancún Q.Roo, México',
  rnt: '042300561bc73', // Bloque 13: RNT SECTUR (dato de la tarjeta de Maggie), pie de la Tarjeta TT
};
